(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["swiga-product-carousel"] && !Shopify.designMode) return;
  try {
    
  const initializeSwigaRails = (scope = document) => {
    scope.querySelectorAll('[data-swiga-rail]').forEach((root) => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const viewport = root.querySelector('[data-rail-viewport]');
      const previous = root.querySelector('[data-rail-prev]');
      const next = root.querySelector('[data-rail-next]');
      if (!viewport) return;

      const move = (direction) => {
        viewport.scrollBy({ left: viewport.clientWidth * 0.82 * direction, behavior: 'smooth' });
      };
      previous?.addEventListener('click', () => move(-1));
      next?.addEventListener('click', () => move(1));
    });
  };

  initializeSwigaRails();
  document.addEventListener('shopify:section:load', (event) => initializeSwigaRails(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["swiga-story-carousel"] && !Shopify.designMode) return;
  try {
    
  const initializeSwigaStories = (scope = document) => {
    scope.querySelectorAll('[data-swiga-story]').forEach((root) => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      const track = root.querySelector('[data-story-track]');
      const slides = Array.from(root.querySelectorAll('[data-story-slide]'));
      const dots = Array.from(root.querySelectorAll('[data-story-dot]'));
      const current = root.querySelector('[data-story-current]');
      const previous = root.querySelector('[data-story-prev]');
      const next = root.querySelector('[data-story-next]');
      let activeIndex = 0;
      let timer;

      if (!track || slides.length < 2) return;

      const show = (index) => {
        activeIndex = (index + slides.length) % slides.length;
        track.style.transform = `translate3d(-${activeIndex * 100}%, 0, 0)`;
        dots.forEach((dot, dotIndex) => {
          const isActive = dotIndex === activeIndex;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-current', String(isActive));
        });
        if (current) current.textContent = String(activeIndex + 1).padStart(2, '0');
      };

      const restart = () => {
        window.clearInterval(timer);
        if (root.dataset.autoplay !== 'true' || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        timer = window.setInterval(() => show(activeIndex + 1), Number(root.dataset.interval) || 7000);
      };

      previous?.addEventListener('click', () => {
        show(activeIndex - 1);
        restart();
      });
      next?.addEventListener('click', () => {
        show(activeIndex + 1);
        restart();
      });
      dots.forEach((dot) => dot.addEventListener('click', () => {
        show(Number(dot.dataset.storyDot));
        restart();
      }));
      root.addEventListener('mouseenter', () => window.clearInterval(timer));
      root.addEventListener('mouseleave', restart);
      restart();
    });
  };

  initializeSwigaStories();
  document.addEventListener('shopify:section:load', (event) => initializeSwigaStories(event.target));

  } catch(e) { console.error(e); }
})();
})();
